const initialState = {
  selectedDomainsObj: [],
  selectedDomainIds: "",
  routingData: [],
  selectedRouting: {},
  selecetdRoutingValue: "",
  countryData:[],
  regionData:[],
  selectedGeoLevel:[],
  definedRegionObj:[]
};

const cmrootReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "cmRootRoutingData":
      state = { ...state, routingData: payload };
      state = { ...state, selectedRouting: payload[payload.length - 1 ] };
      state = { ...state, selecetdRoutingValue: payload[payload.length - 1].id };
      return state;
    case "cmRootUpdateRoutingVal":
      if(payload.name === 'region'){
        state = {...state, selectedGeoLevel:state.definedRegionObj.length===0?state.regionData[0]:state.definedRegionObj};

      }else if(payload.name === 'country' && state.routingData.length > 1){
        state = {...state, selectedGeoLevel:state.countryData[0]};
      }
      else{
      state = {...state, selectedGeoLevel:[]};
      }
      state = { ...state, selectedRouting: payload };
      state = { ...state, selecetdRoutingValue: payload.id };
      return state;
    case "cmRootUpdateDomainVal":
      let allIds = payload.map((obj) => {
        return obj.indexId;
      });
      console.log("new updated",payload)
      state = { ...state, selectedDomainsObj: payload };
      state = { ...state, selectedDomainIds: allIds.toString() };
      return state;
    case "cmRootGetCountryData":
      state = {...state, countryData:payload};
      return state;
    case "cmRootGetRegionData":
      // console.log(payload);
        state = {...state, regionData:payload};
        return state;
    case "cmRootUpdateRegionVal":
      state = {...state, selectedGeoLevel:payload};
      return state;
    case "cmRootUpdateCountryVal":
      state = {...state, selectedGeoLevel:payload};
      return state;
    case "definedRegionObj":
      state = {...state, definedRegionObj:payload};
      return state;
    default:
      return state;
  }
};

export default cmrootReducer;
